<template>
    <div>
        <div>
            <SaasIcon
                icon="svgLogoSellsyText"
                :width="118"
                :height="28"
                viewBox="0 0 118 28"
                class="mr-1 secondary-blue"
            />
        </div>

        <div class="flex-row hp-9">
            <div class="acenter m-auto ai-center">
                <div v-if="isDisplayed">
                    <img
                        src="/ressources/logged/img/errors/lock-closed.svg"
                        :width="210"
                        :height="160"
                    />

                    <h1 class="fs-32 lh-39 font-weight mt-8">
                        {{ title }}
                    </h1>

                    <p class="gray-60 fs-5 lh-26 mt-3 block mb-6">
                        <span v-for="(subtitle, index) in subtitles" :key="index" class="block">
                            {{ subtitle }}
                        </span>
                    </p>
                </div>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitles: {
            type: Array,
            required: false,
            default: [],
        },
        isDisplayed: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>

<style scoped>
.fs-32 {
    font-size: 32px;
}
.lh-39 {
    font-size: 39px;
}
.lh-26 {
    font-size: 26px;
}
.font-weight {
    font-weight: normal;
}
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
</style>
